import React from "react";


function Timing() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/slider-1.png)',backgroundSize:'cover',backgroundPosition:'top'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row">
          <div class="col-md-12" style={{backgroundImage:'url(./images/slider-1.png)',backgroundSize:'cover',backgroundPosition:'center',height:'100px'}}>
                
            </div>
            <div className="col-md-12" style={{background:'#ffffffd2',padding:'50px',border:'1px solid silver'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">Darshan Timings / ദർശന സമയം</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingTop:'15px'}}>
                    {/* <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'700',marginTop:'-20px',textAlign:'center'}}>Alpashi Festival from 16-10-2025 to 31-10-2025</h3>
                      </center> */}
                    {/* first */}


                   
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">04:45 AM - നിർമ്മാല്യ ദർശനം</li>
                                <li className="timelist">07:30 AM - പ്രഭാത പൂജ</li>
                                <li className="timelist">11:00 AM - ഉച്ചപൂജ</li>
                                <li className="timelist">12:00 AM - നടയടപ്പ്</li> 
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                    <li className="timelist">04:30 PM - നട തുറപ്പ്</li>
                                    <li className="timelist">06:30 PM - ദീപാരാധന</li>
                                    <li className="timelist">07:30 PM - അത്താഴപൂജ</li>
                                    <li className="timelist">07:45 PM - നടയടപ്പ്</li>
                                </ul>
                      </div>
                    </div>
                    <p className="timelist">
                       വിശേഷാൽ ദിവസങ്ങളിൽ (എല്ലാ മലയാള മാസവും 1ാം തീയതി, മേടവിഷു, ചിങ്ങത്തിലെ തിരുവോണം, വാർഷിക ഉത്സവ ദിനങ്ങൾ) സമയക്രമത്തിൽ മാറ്റം വരാവുന്നതാണ്
                    </p>
                </div>
           </div> 
            
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;